import { useCallback, useMemo } from "react"
import { useParams } from "react-router-dom"
import { useDeleteConfirm } from "../../../../../../hooks/useDeleteConfirm"
import { useDeviceRolePermissions } from "../../../../../../hooks/useDeviceRolePermissions"
import { DimaFeatureShortNameEnum } from "../../../../../models/Authorization"
import { DeviceRolePermissionGet } from "../../../../../models/DeviceRolePermission"
import { deleteEntity } from "../../../../../utils/deleteEntity"
import { booleanComparator, getDoneIcon, getEmptyIcon } from "../../../../../utils/getBooleanFlagIcon"
import { DiMaAddButton } from "../../../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../../../partials/EntityTab"

export function DeviceRolePermissions() {
  const { deviceId, roleId } = useParams()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()
  const { deviceRolePermissions, isLoadingDeviceRolePermissions } =
    useDeviceRolePermissions(deviceId, roleId)

  const columns = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: `/devices/${deviceId}/roles/${roleId}/permissions`,
    },
    { field: "application", headerName: "Application" },
    {
      field: "hasApplicationRoles",
      headerName: "Has App Roles",
      renderCell: (row: EntityRow) => row.hasApplicationRoles ? getDoneIcon() : getEmptyIcon(),
      sortComparator: booleanComparator,
    },
  ]

  const sorted = [...deviceRolePermissions].sort((a, b) =>
    (a.permission?.name ?? "").localeCompare(b.permission?.name ?? "")
  )

  const rows = sorted.map((permission: DeviceRolePermissionGet) => ({
    id: permission.permission.id,
    name: permission.permission.name,
    application: permission.application.name,
    hasApplicationRoles: permission.applicationRoles.length > 0,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url={`/devices/${deviceId}/roles/${roleId}/permissions/create`}
        feature={DimaFeatureShortNameEnum.AM}
      />
    ),
    [deviceId, roleId]
  )

  const handleActionMenuClick = useCallback((item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() =>
          deleteEntity(
            `/devices/${deviceId}/roles/${roleId}/permissions/${row.id}`
          )
        )
      }
    }, [deviceId, roleId, requestDelete])

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={columns}
        isLoading={isLoadingDeviceRolePermissions}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
